import { gql } from 'graphql-request'
import { DynamicBlockZone } from '../../../lib/strapi/dynamicBlockZones'
import { TextInputData, TextInput } from '../../TextInput'

export type TextInputZoneType = DynamicBlockZone<
  'ComponentPowInputFieldsTextInput',
  Omit<TextInputData, 'register'>
>

export const TextInputFragment = gql`
... on ComponentPowInputFieldsTextInput {
  __typename
  label
  dataLabel
  required
  inputType
}
`

const TextInputZone = (props: TextInputData) => {
  return (
    <TextInput {...props}/>
  )
}

export default TextInputZone
